import { useQuery } from 'react-query';

import { workScheduleQueryKeys } from './queryKeys';
import { fetchWorkScheduleServiceDetails } from './workScheduleApi';

export const useWorkScheduleServiceDetailsQuery = (
  { workScheduleServiceNameId },
  options
) =>
  useQuery(
    workScheduleQueryKeys.serviceDetails(workScheduleServiceNameId),
    () => fetchWorkScheduleServiceDetails({ workScheduleServiceNameId }),
    {
      enabled: Boolean(workScheduleServiceNameId),
      ...options,
    }
  );
